// Definimos a versão da api que está sendo utilizada em todas as requisições
import { version } from './config';

export default {
  enviarFormularioContato(payload) {
    return axios.post(`/api/${version}/contato`, payload)
  }
}
